// extracted by mini-css-extract-plugin
export var copy = "content-preview-column-module--copy--1b265";
export var copyWrapper = "content-preview-column-module--copyWrapper--d323e";
export var date = "content-preview-column-module--date--5568d";
export var description = "content-preview-column-module--description--3eab7";
export var favorite = "content-preview-column-module--favorite--96062";
export var primaryImage = "content-preview-column-module--primary-image--a339c";
export var root = "content-preview-column-module--root--4752f";
export var tags = "content-preview-column-module--tags--6473c";
export var title = "content-preview-column-module--title--0e727";